export default "__VITE_ASSET__BMojmW1$__"